export const AUTH_NO_TOKEN = 'auth_no_token';
export const AUTH_BAD_TOKEN = 'auth_bad_token';
export const PERM_ROLE_TEACHER_ADMIN = 'perm_role_teacher_admin';
